import request from '@/utils/request'

// ==================== 平台零售统计 ====================

/**
 * 获取平台零售概况
 */
export function getPlatformRetailOverview(params) {
  return request({
    url: '/api/retail/statistics/platform/overview',
    method: 'get',
    params
  })
}

/**
 * 获取商家排名统计
 */
export function getMerchantRankStatistics(params) {
  return request({
    url: '/api/retail/statistics/platform/merchant-rank',
    method: 'get',
    params
  })
}

/**
 * 获取门店排名统计（平台视角）
 */
export function getPlatformStoreRankStatistics(params) {
  return request({
    url: '/api/retail/statistics/platform/store-rank',
    method: 'get',
    params
  })
}

/**
 * 获取商品要货数量排名（平台视角）
 */
export function getGoodsPurchaseRankStatistics(params) {
  return request({
    url: '/api/retail/statistics/platform/goods-purchase-rank',
    method: 'get',
    params
  })
}

/**
 * 获取商品销量统计（平台视角）
 */
export function getPlatformGoodsSalesStatistics(params) {
  return request({
    url: '/api/retail/statistics/platform/goods-sales',
    method: 'get',
    params
  })
}

/**
 * 获取库存预警统计（平台视角）
 */
export function getPlatformStockWarningStatistics(params) {
  return request({
    url: '/api/retail/statistics/platform/stock-warning',
    method: 'get',
    params
  })
}

/**
 * 获取要货趋势统计（平台视角）
 */
export function getPlatformPurchaseTrendStatistics(params) {
  return request({
    url: '/api/retail/statistics/platform/purchase-trend',
    method: 'get',
    params
  })
}

/**
 * 获取退货趋势统计（平台视角）
 */
export function getPlatformReturnTrendStatistics(params) {
  return request({
    url: '/api/retail/statistics/platform/return-trend',
    method: 'get',
    params
  })
}

// ==================== 商家零售统计 ====================

/**
 * 获取门店要货利润统计（商家视角）
 * 统计各门店的要货单数据，计算商家和门店的利润
 */
export function getMerchantStorePurchaseProfitStatistics(params) {
  return request({
    url: '/api/retail/statistics/merchant/store-purchase-profit',
    method: 'get',
    params
  })
}

/**
 * 获取平台利润统计（平台视角）
 * 统计各商家的门店要货利润总和
 */
export function getPlatformProfitStatistics(params) {
  return request({
    url: '/api/retail/statistics/platform/profit',
    method: 'get',
    params
  })
}

/**
 * 获取商品利润统计（平台视角）
 * 按商品维度统计利润情况
 */
export function getGoodsProfitStatistics(params) {
  return request({
    url: '/api/retail/statistics/platform/goods-profit',
    method: 'get',
    params
  })
}

/**
 * 获取商品利润统计（商家视角）
 * 按商品维度统计利润情况
 */
export function getMerchantGoodsProfitStatistics(params) {
  return request({
    url: '/api/retail/statistics/merchant/goods-profit',
    method: 'get',
    params
  })
}
